export default __webpack_public_path__ + "static/media/first-aid-procedure.d244b661.pdf";